import {
  Button,
  CircularProgress,
  Container,
  Grid,
  Snackbar,
  Typography,
} from "@material-ui/core";
import Box from "@material-ui/core/Box";
import { Edit } from "@material-ui/icons";
import AddIcon from "@material-ui/icons/Add";
import AddCircleOutlineSharpIcon from "@material-ui/icons/AddCircleOutlineSharp";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import CloseSharpIcon from "@material-ui/icons/CloseSharp";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import ExpandMoreRoundedIcon from "@material-ui/icons/ExpandMoreRounded";
import axios from "axios";
import React, { Component } from "react";
import Modal from "react-awesome-modal";
import { SketchPicker } from "react-color";
import { Navigate } from "react-router";
import edit from "../Assets/Images/edit.png";
import rectangle from "../Assets/Images/Rectangle 54.png";
import verticalLine from "../Assets/Images/Vector 12.png";
import vector from "../Assets/Images/Vector.png";
import yes from "../Assets/Images/yes.png";
import { API } from "../Constants/APIs";
import init from "../Helpers/Windotoken";

export default class ProductEdit extends Component {
  state = {
    visible: false,
    showFirst: false,
    showSecond: false,
    showThird: false,
    showFourth: false,
    compname: "",
    productId: 0,
    Components: [],
    addColor: true,
    type: "color",
    material_value: "",
    compId: 0,
    file: "",
    showMaterials: true,
    variantsCombo: [],
    variantData: [],
    value: 0,
    setValue: 0,
    array1: [],
    array2: [],
    emptyVariants: false,
    emptyComponents: false,
    model_file: "",
    processing: false,
    userdetail: {},
    product: {},
    title: "",
    uploadCount: 0,
    posterImage: "",
    Variants: [],
    deleteConfirmation: false,
    confirmationComponentDelete: false,
    deleteMatId: 0,
    deleteCompId: 0,
    loading: false,
    confirmationComponentAdd: false,
    selectedMaterials: [],
    colorPicker: false,
    link_description: "",
    link_title: "",
    link_url: "",
    active: 0,
    activeComponents: [],
    showAllText: false,
    language: "",
  };
  componentDidMount() {
    this.getSingleProduct();
    this.getUser();
    this.getVariants();
  }
  onImageChange = (event) => {
    this.setState({
      file: event.target.files[0],
    });
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.setState({ swatchFile: e.target.result });
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  };
  selectedComponents = (CompId) => {
    if (this.state.activeComponents.includes(CompId)) {
      let index = this.state.activeComponents.indexOf(CompId);
      this.state.activeComponents.splice(index, 1);
    } else {
      this.state.activeComponents.push(CompId);
    }
  };
  getComponents = () => {
    let pId = document.location.href;
    var url = new URL(pId);
    var productId = url.searchParams.get("id");
    this.setState({ productId });
    axios
      .get(API.getUrls.getComponents + productId + "?page=1&limit=10")
      .then((res) => {
        this.setState(
          {
            Components: res.data.components.docs,
          },

          () => {
            this.state.Components.forEach((item) => {
              this.state.activeComponents.push(item._id);
            });
            this.setState({
              variantsCombo: this.getCombinations(this.state.Components),
              variantData: this.getCombinations(this.state.Components),

              emptyComponents:
                this.state.Components.length === 0 ? true : false,
            });
          }
        );
      });
  };

  isVariantMade = (data) => {
    let i = 0;
    data.forEach((item) => {
      if (item.is_variant_made) {
        i++;
      }
    });
    return i === data.length;
  };
  getUser = () => {
    if (init() === "success") {
      axios.get(API.getUrls.getUser).then((res) => {
        this.setState({ userdetail: res.data.user });
      });
    }
  };

  openModal() {
    this.setState({
      showFirst: true,
      showSecond: false,
      showThird: false,
      showFourth: false,
      visible: true,
    });
  }
  secondModal() {
    this.setState({
      showFirst: false,
      showSecond: true,
      showThird: false,
      showFourth: false,
      visible: true,
    });
  }
  thirdModal() {
    this.setState({
      showFirst: false,
      showSecond: false,
      showThird: true,
      showFourth: false,
      visible: true,
    });
  }
  fourthModal() {
    this.setState({
      showFirst: false,
      showSecond: false,
      showThird: false,
      showFourth: true,
      visible: true,
    });
  }
  closeModal() {
    this.setState({
      visible: false,
      openEdit: false,
      compnentEdit: false,
      materialEdit: false,
    });
    if (this.state.ShowComponent) {
      document.getElementById("componentForm").reset();
    } else {
      document.getElementById("materialForm").reset();
    }
  }
  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  addComponent = (e) => {
    e.preventDefault();
    let authToken = localStorage.getItem("token");
    this.setState({ loading: true });
    let rawData = {
      component_name: this.state.compname,
      product: this.state.productId,
    };
    axios
      .post(API.postUrls.addComponents, rawData, {
        headers: { Authorization: "Bearer " + authToken },
      })
      .then((resp) => {
        if (resp.data.status === "success") {
          this.setState({
            notification: true,
            successMsg: resp.data.message,
            loading: false,
            compId: resp.data.component._id,
            showFirst: true,
            visible: true,
          });
          setTimeout(() => {
            this.setState({ notification: false });
            document.getElementById("componentForm").reset();

            this.getComponents();
          }, 2000);
        } else {
          this.setState({
            notification: true,
            successMsg: resp.data.message,
            loading: false,
          });
          setTimeout(() => {
            this.setState({ notification: false });
          }, 2000);
        }
      });
  };
  addMaterial = (e) => {
    e.preventDefault();

    this.setState({ loading: true });

    let data = new FormData();
    data.append("material_name", this.state.material_name);
    data.append("material_type", this.state.type);
    if (this.state.type === "color") {
      data.append("material_value", this.state.material_value);
    }
    data.append("component", this.state.compId);
    if (this.state.type === "swatch") {
      data.append("swatch_image", this.state.file);
    }
    if (init() === "success") {
      axios.post(API.postUrls.addMaterial, data).then((resp) => {
        if (resp.data.status === "success") {
          this.setState({
            notification: true,
            successMsg: resp.data.message,
            visible: false,
            loading: false,
            swatchFile: "",
            file: "",
          });
          setTimeout(() => {
            this.setState({ notification: false });
            document.getElementById("materialForm").reset();
            this.getComponents();
          }, 2000);
        } else {
          this.setState({
            notification: true,
            successMsg: resp.data.message,
          });
          setTimeout(() => {
            this.setState({ notification: false });
          }, 2000);
        }
      });
    }
  };
  handleFile = (e) => {
    this.setState({ [e.target.name]: e.target.files[0] });
  };
  handleGlbFile = (e) => {
    this.setState({ [e.target.name]: e.target.files[0] }, () => {
      var fileName = document.getElementById("uploaddoc").value.toLowerCase();
      if (!fileName.endsWith(".glb")) {
        alert("Please upload .glb file only.");
        return false;
      } else {
        this.setState({
          uploadGlb: true,
        });
      }
    });
  };
  handlevariantModal = (e) => {
    this.setState({ [e.target.name]: e.target.files[0] }, () => {
      var fileName = document
        .getElementById("uploadVariant")
        .value.toLowerCase();
      if (!fileName.endsWith(".glb")) {
        alert("Please upload .glb file only.");
        return false;
      }
    });
  };

  getCombinations(arr) {
    if (arr.length === 0) return [[]];
    let [current, ...rest] = arr;
    let combinations = this.getCombinations(rest);
    return current.materials.reduce(
      (a, string) => [...a, ...combinations.map((c) => [string, ...c])],
      []
    );
  }
  handleChangeComplete = (color) => {
    this.setState({ material_value: color.hex });
  };
  addVariants = (e) => {
    // console.log(this.state.variantsCombo);
    e.preventDefault();
    if (this.state.variantsCombo[0].length === 0) {
      alert("Please add components.");
    } else {
      let count = 0;
      this.state.variantsCombo.forEach((isVariant, index) => {
        if (!this.isVariantMade(isVariant)) {
          if (!this.state["model_file" + index]) {
            count++;
          }
        }
      });
      if (count > 0) {
        alert("please upload files");
        return;
      }
      this.state.variantsCombo.forEach((singleVariant, index) => {
        let data = new FormData();

        singleVariant.forEach((some) => {
          data.append("materials[]", some._id);
        });

        data.append("model_file", this.state["model_file" + index]);
        this.setState({ processing: true });
        axios
          .post(API.postUrls.addVariants + "/" + this.state.productId, data)
          .then((res) => {
            this.setState({
              uploadCount: this.state.uploadCount + 1,
            });
          });
      });

      if (count === this.state.variantsCombo.length) {
        this.setState({
          processing: false,
          notification: true,
          successMsg: "Variant Added Successfully",
        });
        setTimeout(() => {
          this.setState({ notification: false });
        }, 2000);
      }
    }
  };
  getSingleProduct = () => {
    let pId = document.location.href;
    var url = new URL(pId);
    var productId = url.searchParams.get("id");
    if (init() === "success") {
      axios.get(API.getUrls.getProducts + "/" + productId).then((res) => {
        this.setState({
          product: res.data.product,
          language: res.data.product.language,
        });
      });
    }
  };
  updateProduct = (e) => {
    e.preventDefault();
    this.setState({ loading: true });

    let data = new FormData();
    data.append("title", this.state.title);
    if (this.state.filename) {
      data.append("posterImage", this.state.filename);
    }

    this.state.product.categories.forEach((cat) => {
      data.append("categories[]", cat._id);
    });
    data.append("link_url", this.state.link_url);
    data.append("link_title", this.state.link_title);
    data.append("link_description", this.state.link_description);
    data.append("language", this.state.language);
    if (init() === "success") {
      axios
        .put(API.postUrls.addproduct + "/" + this.state.product._id, data)
        .then((resp) => {
          if (resp.data.status === "success") {
            this.setState({
              notification: true,
              loading: false,
              successMsg: resp.data.message,
              productadded: true,
              openEdit: false,
              openBuyNow: false,
            });
            setTimeout(() => {
              this.setState({ notification: false });
              this.getSingleProduct();
            }, 2000);
          } else {
            this.setState({
              notification: true,
              successMsg: resp.data.message,
              loading: false,
            });
            setTimeout(() => {
              this.setState({ notification: false });
            }, 2000);
          }
        });
    }
  };
  updateComponent = (e) => {
    e.preventDefault();
    let authToken = localStorage.getItem("token");
    this.setState({ loading: true });
    let rawData = {
      component_name: this.state.compname,
      product: this.state.productId,
    };
    axios
      .put(API.postUrls.addComponents + "/" + this.state.compId, rawData, {
        headers: { Authorization: "Bearer " + authToken },
      })
      .then((resp) => {
        if (resp.data.status === "success") {
          this.setState({
            notification: true,
            successMsg: resp.data.message,
            loading: false,
            compnentEdit: false,
          });
          setTimeout(() => {
            this.setState({ notification: false });

            this.getComponents();
          }, 2000);
        } else {
          this.setState({
            notification: true,
            successMsg: resp.data.message,
          });
          setTimeout(() => {
            this.setState({ notification: false });
          }, 2000);
        }
      });
  };
  updateMaterial = (e) => {
    e.preventDefault();

    this.setState({ loading: true });

    let data = new FormData();
    data.append("material_name", this.state.material_name);
    data.append("material_type", this.state.type);
    if (this.state.type === "color") {
      data.append("material_value", this.state.material_value);
    }
    data.append("component", this.state.compId);
    if (this.state.type === "swatch") {
      data.append("swatch_image", this.state.file);
    }
    if (init() === "success") {
      axios
        .put(API.postUrls.addMaterial + "/" + this.state.material_id, data)
        .then((resp) => {
          if (resp.data.status === "success") {
            this.setState({
              notification: true,
              successMsg: resp.data.message,
              visible: false,
              loading: false,
              materialEdit: false,
            });
            setTimeout(() => {
              this.setState({ notification: false });
              this.getComponents();
            }, 2000);
          } else {
            this.setState({
              notification: true,
              successMsg: resp.data.message,
            });
            setTimeout(() => {
              this.setState({ notification: false });
            }, 2000);
          }
        });
    }
  };
  openEditModal = () => {
    this.setState({
      openEdit: true,
    });
  };
  getVariants = () => {
    let pId = document.location.href;
    var url = new URL(pId);
    var productId = url.searchParams.get("id");
    axios
      .get(API.getUrls.variants + "?page=1&limit=10&product=" + productId)
      .then((res) => {
        this.setState(
          {
            Variants: res.data.docs,
          },
          () => {
            this.getComponents();
          }
        );
      });
  };

  variantDelete = () => {
    let pId = document.location.href;
    var url = new URL(pId);
    var productId = url.searchParams.get("id");
    if (this.state.Variants.length > 0) {
      if (init() === "success") {
        axios
          .delete(API.postUrls.deleteAllVariants + "/" + productId)
          .then((res) => {
            if (res.data.status === "success") {
              this.setState({
                notification: true,
                successMsg: res.data.message,
                confirmationComponentAdd: false,
              });
              setTimeout(() => {
                this.setState({
                  notification: false,
                });
                window.location.reload();
              }, 5000);
            }
          });
      }
    }
  };
  deleteMaterial = (id, isValid) => {
    if (init() === "success") {
      axios.delete(API.postUrls.addMaterial + "/" + id).then((res) => {
        if (res.data.status === "failed") {
          this.setState(
            {
              notification: true,
              successMsg: res.data.message,
              deleteConfirmation: false,
            },
            () => {
              if (this.state.Variants.length > 0) {
                this.state.Variants.forEach((item) => {
                  item.materials.forEach((mat) => {
                    if (mat.is_variant_made === isValid && mat._id === id) {
                      if (init() === "success") {
                        axios
                          .delete(API.getUrls.variants + "/" + item._id)
                          .then((res) => {
                            if (res.data.status === "success") {
                              this.setState({
                                notification: true,
                                successMsg: res.data.message,
                                deleteConfirmation: false,
                              });
                              this.getVariants();
                            }
                          });
                      }
                    }
                  });
                });
              }
            }
          );
          setTimeout(() => {
            this.setState({
              notification: false,
            });
          }, 5000);
          this.getComponents();
        }
      });
    }
  };
  deleteComponent = (id) => {
    let authToken = localStorage.getItem("token");
    this.setState({ loading: true });

    axios
      .delete(API.postUrls.addComponents + "/" + id, {
        headers: { Authorization: "Bearer " + authToken },
      })
      .then((resp) => {
        if (resp.data.status === "failed") {
          this.setState({
            notification: true,
            successMsg: resp.data.message,
            confirmationComponentDelete: false,
          });
          setTimeout(() => {
            this.setState({
              notification: false,
            });
          }, 5000);
          this.variantDelete();
          this.getComponents();
        } else {
          this.setState({
            notification: true,
            successMsg: resp.data.message,
            confirmationComponentDelete: false,
          });
          setTimeout(() => {
            this.setState({
              notification: false,
            });
          }, 2000);
          this.variantDelete();
          this.getComponents();
        }
      });
  };

  variant_update = (id) => {
    if (init() === "success") {
      this.setState({ loading: true });
      let data = new FormData();

      data.append("model_file", this.state.model_file);
      axios.put(API.postUrls.addVariants + "/" + id, data).then((res) => {
        if (res.data.status === "success") {
          this.setState({
            notification: true,
            successMsg: res.data.message,
            confirmationComponentAdd: false,
          });
          setTimeout(() => {
            this.setState({
              notification: false,
              variantUpdate: false,
            });
          }, 3000);
        }
      });
    }
  };
  render() {
    if (
      this.state.uploadCount === this.state.variantsCombo.length &&
      this.state.variantsCombo.length > 0
    ) {
      return <Navigate to={"/viewer/" + "?id=" + this.state.productId} />;
    } else {
      return (
        <Container className="containerSpacingdashBoard" maxWidth={"lg"}>
          {this.state.notification ? (
            <Snackbar
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              open={true}
              style={{ bottom: "40px", textTransform: "capitalize" }}
              color={"#bdbdbd"}
              autoHideDuration={6000}
              message={this.state.successMsg}
            ></Snackbar>
          ) : null}
          <form action="" onSubmit={this.addVariants}>
            <Grid
              container
              spacing={2}
              className="editWrapper"
              style={{ marginTop: "25px" }}
            >
              <Grid item sm={9}>
                <div className="editLeftWrapper">
                  <Grid container spacing={2}>
                    <Grid item sm={6}>
                      <Typography className="heading">
                        Please Upload the right files for each material
                        combination listed below
                      </Typography>
                    </Grid>
                    <Grid item sm={6}>
                      <div
                        className="checkboxWrapper"
                        style={{ marginTop: "-15px" }}
                      >
                        <Typography className="heading">
                          Create 3D Model from my 2D files?
                        </Typography>
                        <input type="checkbox" className="checkInput" />
                      </div>
                      <Typography className="heading">
                        Price : $300 per model
                      </Typography>
                    </Grid>
                  </Grid>
                  {this.state.emptyComponents ? (
                    <div>
                      <Grid
                        container
                        spacing={2}
                        style={{
                          borderBottom: "1px solid rgb(229 225 225)",
                          width: " 99%",
                          marginLeft: "1px",
                        }}
                      ></Grid>
                      <Typography
                        style={{ marginTop: "50px", textAlign: "center" }}
                      >
                        Components not available.
                      </Typography>
                    </div>
                  ) : (
                    <div>
                      <Grid
                        container
                        spacing={2}
                        style={{
                          borderBottom: "1px solid rgb(229 225 225)",
                          width: " 99%",
                          marginLeft: "1px",
                        }}
                      >
                        {this.state.Components.map((component) => (
                          <Grid item sm={3} className="rowHead">
                            {component.component_name}
                          </Grid>
                        ))}
                        <Grid item sm={3} className="rowHead">
                          Action
                        </Grid>
                      </Grid>
                      {/* Variants Mapping */}
                      <div>
                        <div>
                          {this.state.Variants.map((items, index) => (
                            <Grid container spacing={2}>
                              {items.materials.map((variant) => (
                                <Grid item sm={3} className="checkboxWrapper">
                                  {variant.material_type === "color" ? (
                                    <p
                                      className="checkBox"
                                      style={{
                                        backgroundColor: variant.material_value,
                                        marginTop: "22px",
                                      }}
                                    ></p>
                                  ) : (
                                    <img
                                      src={API.imgUrl + variant.material_value}
                                      style={{ marginTop: "22px" }}
                                      className="checkBox"
                                      alt=""
                                    />
                                  )}
                                  <span
                                    className="checkText"
                                    style={{
                                      width: "150px",
                                      wordBreak: "break-all",
                                    }}
                                  >
                                    {variant.material_name}
                                  </span>
                                </Grid>
                              ))}
                              <Grid item sm={3} className="checkboxWrapper">
                                <Button
                                  variant="outlined"
                                  size="medium"
                                  className="uploadbtn"
                                  component="label"
                                  style={{
                                    width: "100%",
                                    marginRight: "10px",
                                    textTransform: "capitalize",
                                    fontSize: "16px",
                                    background: "#185a18",
                                  }}
                                  key={index}
                                  onClick={() =>
                                    this.setState({
                                      variantUpdate: true,
                                      variantId: items._id,
                                    })
                                  }
                                >
                                  <CheckIcon
                                    style={{
                                      color: "#fff",
                                      fontSize: "30px",
                                    }}
                                  />
                                </Button>

                                <Button className="uploadbtn">
                                  <img src={vector} alt="" />
                                </Button>
                              </Grid>
                            </Grid>
                          ))}
                        </div>
                        <div>
                          {this.state.variantsCombo.map((vari, index) =>
                            !this.isVariantMade(vari) ? (
                              <Grid container spacing={2}>
                                {vari.map((variant) => (
                                  <Grid item sm={3} className="checkboxWrapper">
                                    {variant.material_type === "color" ? (
                                      <p
                                        className="checkBox"
                                        style={{
                                          backgroundColor:
                                            variant.material_value,
                                          marginTop: "22px",
                                        }}
                                      ></p>
                                    ) : (
                                      <img
                                        src={
                                          API.imgUrl + variant.material_value
                                        }
                                        style={{ marginTop: "22px" }}
                                        className="checkBox"
                                        alt=""
                                      />
                                    )}
                                    <span
                                      className="checkText"
                                      style={{
                                        width: "150px",
                                        wordBreak: "break-all",
                                      }}
                                    >
                                      {variant.material_name}
                                    </span>
                                  </Grid>
                                ))}
                                <Grid item sm={3} className="checkboxWrapper">
                                  <Button
                                    variant="outlined"
                                    size="medium"
                                    className="uploadbtn"
                                    component="label"
                                    style={{
                                      width: "100%",
                                      marginRight: "10px",
                                      textTransform: "capitalize",
                                      fontSize: "16px",
                                      background:
                                        this.state["model_file" + index] &&
                                        this.state.uploadGlb
                                          ? "#185a18"
                                          : "#bdbdbd",
                                    }}
                                    key={index}
                                  >
                                    {this.state["model_file" + index] &&
                                    this.state.uploadGlb ? (
                                      <CheckIcon
                                        style={{
                                          color: "#fff",
                                          fontSize: "30px",
                                        }}
                                      />
                                    ) : (
                                      "Upload"
                                    )}

                                    <input
                                      type="file"
                                      onChange={this.handleGlbFile}
                                      name={"model_file" + index}
                                      hidden
                                      id="uploaddoc"
                                      className="imageUpload"
                                    />
                                  </Button>

                                  <Button className="uploadbtn">
                                    <img src={vector} alt="" />
                                  </Button>
                                </Grid>
                              </Grid>
                            ) : null
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </Grid>
              <Grid item sm={3}>
                <div className="editRightWrapper">
                  <div className="box1 " style={{ position: "relative" }}>
                    <div
                      className="inlineWrapper"
                      style={{ marginBottom: "20px" }}
                    >
                      <Typography
                        className="compName"
                        style={{
                          textTransform: "capitalize",
                          fontWeight: 600,
                          fontSize: "18px",
                          marginTop: "35px",
                        }}
                      >
                        {this.state.product
                          ? this.state.product.title
                          : "  Product name not available"}
                      </Typography>
                    </div>
                    <br />
                    <Typography
                      className="compName"
                      style={{ marginTop: "-15px" }}
                    >
                      {this.state.userdetail.company_name === "undefined"
                        ? "Company name not available"
                        : this.state.userdetail.company_name
                        ? this.state.userdetail.company_name
                        : null}
                    </Typography>
                    <img
                      src={edit}
                      width="20px"
                      height="20px"
                      style={{
                        position: "absolute",
                        right: "6%",
                        top: "33%",
                        cursor: "pointer",
                      }}
                      alt=""
                      onClick={() => {
                        this.openEditModal();
                      }}
                    />
                    <p
                      style={{
                        fontWeight: "bold",
                        position: "absolute",
                        right: "5%",
                        top: "21%",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        this.openEditModal();
                      }}
                    >
                      __
                    </p>
                  </div>
                  <div
                    className="box1"
                    style={{
                      position: "relative",
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    <div className="inlineWrapper">
                      <Typography
                        className="buyNow"
                        style={{ fontWeight: "bold", cursor: "pointer" }}
                        onClick={() => {
                          this.setState({ openBuyNow: true });
                        }}
                      >
                        {this.state.product.link_title
                          ? this.state.product.link_title
                          : "Buy Now"}
                      </Typography>
                      <br />

                      <img
                        width="20px"
                        height="20px"
                        style={{
                          position: "absolute",
                          right: "7%",
                          cursor: "pointer",
                        }}
                        src={edit}
                        alt=""
                        onClick={() => {
                          this.setState({ openBuyNow: true });
                        }}
                      />
                      <p
                        style={{
                          fontWeight: "bold",
                          position: "absolute",
                          right: "6%",
                          top: "22%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          this.setState({ openBuyNow: true });
                        }}
                      >
                        __
                      </p>
                    </div>
                    <br />
                    <Typography
                      className="buyNow"
                      style={{
                        cursor: "pointer",
                        fontSize: "12px",
                        letterSpacing: "0px",
                        position: "absolute",
                        bottom: "10px",
                      }}
                      onClick={() => {
                        this.setState({ openBuyNow: true });
                      }}
                    >
                      {this.state.product.link_description
                        ? this.state.product.link_description
                        : ""}
                    </Typography>
                  </div>

                  {/* Components Mapping */}
                  {this.state.Components
                    ? this.state.Components.map((comp, index) => (
                        <div className="parentDiv">
                          <div
                            className="box1"
                            style={{
                              width: "100%",
                              height: this.state.activeComponents.includes(
                                comp._id
                              )
                                ? "226px"
                                : "38px",
                              overflowY: this.state.activeComponents.includes(
                                comp._id
                              )
                                ? "auto"
                                : "",
                              position: "relative",
                              transitionDuration: "222ms",
                            }}
                          >
                            <ExpandMoreRoundedIcon
                              className="downArrow"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                this.selectedComponents(comp._id);

                                this.setState({
                                  showMaterials:
                                    this.state.activeComponents.includes(
                                      comp._id
                                    )
                                      ? true
                                      : false,
                                });
                              }}
                            />
                            <CloseIcon
                              onClick={() => {
                                this.setState({
                                  confirmationComponentDelete: true,
                                  deleteCompId: comp._id,
                                });
                              }}
                              style={{
                                color: "#bdbdbd",
                                fontSize: "18px",
                                position: "absolute",
                                right: "40px",
                                top: "17px",
                                cursor: "pointer",
                              }}
                            />
                            <div
                              className="inlineWrapper"
                              style={{ marginLeft: "10px", cursor: "pointer" }}
                            >
                              <Typography
                                className="buyNow"
                                style={{ cursor: "pointer" }}
                              >
                                {comp.component_name}
                              </Typography>

                              <EditOutlinedIcon
                                style={{
                                  marginLeft: "10px",
                                  marginTop: "16px",
                                  cursor: "pointer",
                                  position: "absolute",
                                  right:
                                    window.innerWidth < 1000 ? "56px" : "64px",
                                  top: "2px",
                                  fontSize: "16px",
                                  color: "#bdbdbd",
                                }}
                                onClick={() =>
                                  this.setState({
                                    compId: comp._id,
                                    compnentEdit: true,
                                    component_name: comp.component_name,
                                  })
                                }
                              />
                            </div>
                            <br />
                            {this.state.activeComponents.includes(comp._id) ? (
                              <div
                                className="inlineWrapper"
                                style={{ marginLeft: "3px" }}
                              >
                                {comp
                                  ? comp.materials.length > 0
                                    ? comp.materials.map((singleMat, index) => (
                                        <div>
                                          {singleMat ? (
                                            singleMat.material_type ? (
                                              singleMat.material_type ===
                                              "color" ? (
                                                <div
                                                  style={{
                                                    paddingRight: "10px",
                                                    width: "25%",
                                                  }}
                                                >
                                                  <div
                                                    className="smallBox"
                                                    onClick={() => {
                                                      this.setState({
                                                        material_value:
                                                          singleMat.material_value,
                                                        material_name:
                                                          singleMat.material_name,
                                                        compId: comp._id,
                                                        material_id:
                                                          singleMat._id,
                                                      });
                                                    }}
                                                    style={{
                                                      backgroundColor:
                                                        singleMat.material_value,
                                                      position: "relative",
                                                      cursor: "pointer",
                                                    }}
                                                  >
                                                    <CloseIcon
                                                      onClick={() => {
                                                        this.setState({
                                                          deleteConfirmation: true,
                                                          deleteMatId:
                                                            singleMat._id,
                                                          isAvailable:
                                                            singleMat.is_variant_made,
                                                        });
                                                      }}
                                                      style={{
                                                        color: "#fff",
                                                        fontSize: "13px",
                                                        position: "absolute",
                                                        right: "-7px",
                                                        top: "-8px",
                                                        cursor: "pointer",
                                                        background: "gray",
                                                        borderRadius: "10px",
                                                      }}
                                                    />
                                                    <Edit
                                                      onClick={() => {
                                                        this.setState({
                                                          materialEdit: true,
                                                          addColor:
                                                            this.state.type ===
                                                            "color"
                                                              ? true
                                                              : false,
                                                        });
                                                      }}
                                                      style={{
                                                        color: "#fff",
                                                        fontSize: "22px",
                                                        position: "absolute",
                                                        right: "14px",
                                                        top: "14px",
                                                        cursor: "pointer",
                                                      }}
                                                    />
                                                  </div>
                                                </div>
                                              ) : (
                                                <div
                                                  style={{
                                                    position: "relative",
                                                    width: "70px",
                                                    height: "53px",
                                                  }}
                                                >
                                                  <img
                                                    className="smallBox"
                                                    style={{
                                                      background: "transparent",
                                                      position: "relative",
                                                      cursor: "pointer",
                                                    }}
                                                    src={
                                                      API.imgUrl +
                                                      singleMat.material_value
                                                    }
                                                    alt=""
                                                    onClick={() => {
                                                      this.setState({
                                                        materialEdit: true,
                                                        material_value:
                                                          singleMat.material_value,
                                                        material_name:
                                                          singleMat.material_name,
                                                        material_id:
                                                          singleMat._id,
                                                        compId: comp._id,
                                                        addSwatch:
                                                          this.state.type ===
                                                          "swatch"
                                                            ? true
                                                            : false,
                                                        addColor:
                                                          this.state.type ===
                                                          "swatch"
                                                            ? false
                                                            : true,
                                                      });
                                                    }}
                                                  />
                                                  <CloseIcon
                                                    onClick={() => {
                                                      this.setState({
                                                        deleteConfirmation: true,
                                                        deleteMatId:
                                                          singleMat._id,
                                                        isAvailable:
                                                          singleMat.is_variant_made,
                                                      });
                                                    }}
                                                    style={{
                                                      color: "#fff",
                                                      fontSize: "13px",
                                                      position: "absolute",
                                                      right: "-1px",
                                                      top: "-8px",
                                                      cursor: "pointer",
                                                      background: "gray",
                                                      borderRadius: "10px",
                                                    }}
                                                  />
                                                  <Edit
                                                    onClick={() => {
                                                      this.setState({
                                                        materialEdit: true,
                                                        material_value:
                                                          singleMat.material_value,
                                                        material_name:
                                                          singleMat.material_name,
                                                        material_id:
                                                          singleMat._id,
                                                        compId: comp._id,
                                                        addSwatch:
                                                          this.state.type ===
                                                          "swatch"
                                                            ? true
                                                            : false,
                                                        addColor:
                                                          this.state.type ===
                                                          "swatch"
                                                            ? false
                                                            : true,
                                                      });
                                                    }}
                                                    style={{
                                                      color: "#fff",
                                                      fontSize: "22px",
                                                      position: "absolute",
                                                      right: "22px",
                                                      top: "14px",
                                                      cursor: "pointer",
                                                    }}
                                                  />
                                                </div>
                                              )
                                            ) : null
                                          ) : null}
                                          <div
                                            style={{
                                              paddingRight: "10px",
                                              width: "70%",

                                              paddingLeft: "6px",
                                              marginTop: "-7px",
                                              inlineSize: "60px",
                                              overflowWrap: "break-word",
                                            }}
                                          >
                                            <p
                                              style={{
                                                fontSize:
                                                  window.innerWidth < 1100
                                                    ? "12px"
                                                    : "14px",
                                                fontFamily: "Inter",
                                                textAlign: "center",
                                                cursor: "pointer",
                                                textTransform: "capitalize",
                                              }}
                                              onClick={() =>
                                                this.state.showAllText
                                                  ? this.setState({
                                                      showAllText: false,
                                                    })
                                                  : this.setState({
                                                      showAllText: true,
                                                    })
                                              }
                                            >
                                              {singleMat
                                                ? singleMat.material_name
                                                    .length <= 25
                                                  ? singleMat.material_name
                                                  : singleMat.material_name.substring(
                                                      0,
                                                      10
                                                    ) + "..."
                                                : null}
                                            </p>
                                          </div>
                                        </div>
                                      ))
                                    : null
                                  : null}

                                <br />

                                <div
                                  className="secondBox"
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    this.setState(
                                      { compId: comp._id, material_value: "" },
                                      () => {
                                        this.openModal();
                                      }
                                    )
                                  }
                                >
                                  <AddIcon
                                    style={{
                                      marginTop: "14px",
                                      color: "gray",
                                      cursor: "pointer",
                                    }}
                                  />

                                  <Typography
                                    className="default"
                                    style={{
                                      marginLeft: "0px",
                                      width: "55px",
                                      lineHeight: "19px",
                                    }}
                                  >
                                    Add Material
                                  </Typography>
                                </div>
                              </div>
                            ) : null}

                            <br />
                          </div>
                        </div>
                      ))
                    : null}

                  {this.state.Variants.length > 0 ? (
                    <div
                      className="addComp"
                      onClick={() =>
                        this.setState({
                          confirmationComponentAdd: true,
                        })
                      }
                    >
                      <div className="inlineWrapper">
                        <Typography className="text">Add Component</Typography>

                        <AddCircleOutlineSharpIcon
                          style={{
                            position: "absolute",
                            right: "23px",
                            top: "15px",
                          }}
                        />
                      </div>
                    </div>
                  ) : (
                    <div
                      className="addComp"
                      onClick={() =>
                        this.setState({
                          ShowComponent: true,
                          showFirst: false,
                          showSecond: false,
                          showThird: false,
                          showFourth: false,
                          visible: true,
                        })
                      }
                    >
                      <div className="inlineWrapper">
                        <Typography className="text">Add Component</Typography>

                        <AddCircleOutlineSharpIcon
                          style={{
                            position: "absolute",
                            right: "23px",
                            top: "15px",
                          }}
                        />
                      </div>
                    </div>
                  )}

                  <div className="addComp">
                    <Typography className="text"> Status : New</Typography>
                  </div>

                  <Button
                    className="saveBtn"
                    type="submit"
                    style={{ width: "109%" }}
                  >
                    Save
                  </Button>

                  <Typography style={{ color: "red" }}>
                    {this.state.warn1 ? "* Modal file is required." : ""}
                  </Typography>
                </div>
              </Grid>
            </Grid>
          </form>
          <Modal
            visible={this.state.visible}
            width="300"
            height="470"
            effect="fadeInUp"
            onClickAway={() => this.closeModal()}
          >
            {this.state.showFirst ? (
              <div className="modalWrapper">
                <img
                  src={yes}
                  alt=""
                  style={{ position: "absolute", right: "44px", top: "10px" }}
                />
                <CloseSharpIcon
                  style={{ position: "absolute", right: "10px", top: "5px" }}
                  onClick={() => this.closeModal()}
                />
                <form action="" id="materialForm" onSubmit={this.addMaterial}>
                  <h1 className="modalHead">Preview</h1>
                  {this.state.type === "color" ? (
                    <div
                      className="modalBox"
                      style={{
                        backgroundColor: this.state.material_value
                          ? this.state.material_value
                          : "red",
                      }}
                    ></div>
                  ) : (
                    <div>
                      {this.state.swatchFile ? (
                        <img
                          src={this.state.swatchFile}
                          width="105px"
                          height="105px"
                          style={{ marginBottom: "10px" }}
                          alt=""
                        />
                      ) : (
                        <img
                          src={rectangle}
                          width="105px"
                          height="105px"
                          style={{ marginBottom: "10px" }}
                          alt=""
                        />
                      )}
                    </div>
                  )}
                  <div className="inputTextWrap">
                    <span className="modalText">Name</span>
                    <input
                      type="text"
                      className="modalInput"
                      required
                      name="material_name"
                      onChange={this.handleInput}
                    />
                  </div>

                  <Typography className="modalMaterialHead">
                    {" "}
                    Material
                  </Typography>

                  <div style={{ marginBottom: "20px" }}>
                    <span
                      className="modalMaterialHead"
                      style={{
                        marginRight: "80px",
                        borderBottom: "none",
                        fontWeight: this.state.type === "color" ? "bold" : 400,
                      }}
                      onClick={() =>
                        this.setState({
                          addColor: true,
                          addSwatch: false,
                          type: "color",
                        })
                      }
                    >
                      Solid Color
                    </span>
                    <img src={verticalLine} className="varticalLine" alt="" />

                    <span
                      className="modalText"
                      style={{
                        fontWeight: this.state.type === "swatch" ? "bold" : 400,
                      }}
                      onClick={() =>
                        this.setState({
                          addSwatch: true,
                          addColor: false,
                          type: "swatch",
                        })
                      }
                    >
                      Swatch
                    </span>
                  </div>

                  {this.state.addColor ? (
                    <div>
                      <div
                        className={
                          this.state.colorPicker
                            ? "inputTextWrap2"
                            : "inputTextWrap"
                        }
                      >
                        <span
                          className="modalText"
                          style={{ marginLeft: " -8px" }}
                        >
                          Hexcode
                        </span>
                        <input
                          type="text"
                          className="modalInput"
                          name="material_value"
                          value={
                            this.state.material_value
                              ? this.state.material_value
                              : "#ff0000"
                          }
                          onClick={() =>
                            this.setState({
                              colorPicker: !this.state.colorPicker,
                            })
                          }
                        />
                        {this.state.colorPicker ? (
                          <SketchPicker
                            name="material_value"
                            color={this.state.material_value}
                            onChangeComplete={this.handleChangeComplete}
                            width="350px"
                          />
                        ) : null}
                      </div>
                    </div>
                  ) : null}
                  {this.state.addSwatch ? (
                    <div>
                      <Button
                        variant="outlined"
                        size="medium"
                        className="uploadbtnswatch"
                        component="label"
                        style={{ margin: "11px auto" }}
                      >
                        Upload Swatch
                        <input
                          type="file"
                          onChange={this.onImageChange}
                          name="file"
                          hidden
                        />
                      </Button>
                      <Typography className="modalHead">
                        {this.state.file
                          ? "Swatch Uploaded"
                          : "accepted file types : .jpeg, .png"}
                      </Typography>
                    </div>
                  ) : null}
                  <Button
                    className={
                      this.state.colorPicker
                        ? "uploadbtnswatchPicker"
                        : "uploadbtnswatch"
                    }
                    type="submit"
                  >
                    Add Material
                  </Button>
                </form>
              </div>
            ) : null}

            {this.state.ShowComponent ? (
              <div className="modalWrapper" style={{ marginTop: "115px" }}>
                <form action="" id="componentForm" onSubmit={this.addComponent}>
                  <h1 className="modalHead" style={{ fontSize: "18px" }}>
                    Add Component
                  </h1>
                  <img
                    src={yes}
                    alt=""
                    style={{ position: "absolute", right: "44px", top: "10px" }}
                  />
                  <CloseSharpIcon
                    style={{ position: "absolute", right: "10px", top: "5px" }}
                    onClick={() => this.closeModal()}
                  />

                  <div className="inputTextWrap">
                    <span className="modalText">Name</span>
                    <input
                      type="text"
                      className="modalInput"
                      name="compname"
                      required
                      onChange={this.handleInput}
                    />
                  </div>
                  <br />
                  <Button className="addBtn" type="submit">
                    {this.state.loading ? (
                      <CircularProgress color={"white"} size={25} />
                    ) : (
                      "Add Component"
                    )}
                  </Button>
                </form>
              </div>
            ) : null}
          </Modal>
          <Modal
            visible={this.state.processing}
            width="450"
            height="200"
            effect="fadeInUp"
          >
            <div style={{ textAlign: "center", marginTop: "66px" }}>
              <p>Please wait...</p>
              <Box sx={{ position: "relative", display: "inline-flex" }}>
                <CircularProgress
                  color={"info"}
                  variant="determinate"
                  value={Math.round(
                    (100 / this.state.variantsCombo.length) *
                      this.state.uploadCount
                  )}
                />
                <Box
                  sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: "absolute",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    variant="caption"
                    component="div"
                    color="text.secondary"
                  >
                    {`${Math.round(
                      (100 / this.state.variantsCombo.length) *
                        this.state.uploadCount
                    )}%`}
                  </Typography>
                </Box>
              </Box>

              <p>
                {this.state.uploadCount +
                  "/" +
                  this.state.variantsCombo.length +
                  " models are uploaded"}
              </p>
            </div>
          </Modal>
          <Modal
            visible={this.state.openEdit}
            width="350"
            height="550"
            effect="fadeInUp"
            onClickAway={() => this.closeModal()}
          >
            <div className="modalWrapper">
              <h4>Edit product details</h4>
              <form action="" onSubmit={this.updateProduct}>
                <Typography>
                  {this.state.filename ? "File updated" : null}
                </Typography>
                <br />
                <div className="contentWrap">
                  <p>Product Name</p>
                  <input
                    type="text"
                    name="title"
                    className="modalInput"
                    style={{ marginBottom: "10px" }}
                    defaultValue={
                      this.state.product ? this.state.product.title : ""
                    }
                    onChange={this.handleInput}
                    required
                  />
                  <Typography className="buyNow">Select Language</Typography>
                  <select
                    name="language"
                    id=""
                    className="modalInput"
                    style={{ width: "100%" }}
                    value={this.state.language}
                    onChange={this.handleInput}
                  >
                    <option value="English">English</option>
                    <option value="French">French</option>
                  </select>
                  <p> Upload Document</p>
                  <Button
                    variant="outlined"
                    size="medium"
                    className="uploadbtn"
                    component="label"
                    style={{
                      border: "1px solid #bdbdbd",
                      width: "100%",
                      textTransform: "capitalize",
                      background: "#bdbdbd73",
                      marginBottom: "10px",
                    }}
                  >
                    Upload Image
                    <input
                      type="file"
                      onChange={this.handleFile}
                      name="filename"
                      hidden
                    />
                  </Button>
                  <br />
                  <Button
                    className="addBtn"
                    type="submit"
                    style={{ width: "100%", marginLeft: "0px" }}
                  >
                    {this.state.loading ? (
                      <CircularProgress color={"white"} size={25} />
                    ) : (
                      "Update"
                    )}
                  </Button>
                </div>
              </form>
            </div>
          </Modal>
          <Modal
            visible={this.state.compnentEdit}
            width="300"
            height="350"
            effect="fadeInUp"
            onClickAway={() => this.closeModal()}
          >
            <div className="modalWrapper" style={{ marginTop: "80px" }}>
              <form
                action=""
                id="componentForm"
                onSubmit={this.updateComponent}
              >
                <h1 className="modalHead" style={{ fontSize: "18px" }}>
                  Edit component details
                </h1>

                <CloseSharpIcon
                  style={{ position: "absolute", right: "10px", top: "5px" }}
                  onClick={() => this.closeModal()}
                />

                <div className="inputTextWrap">
                  <span className="modalText">Name</span>
                  <input
                    type="text"
                    className="modalInput"
                    name="compname"
                    defaultValue={this.state.component_name}
                    required
                    onChange={this.handleInput}
                  />
                </div>
                <br />
                <Button className="addBtn" type="submit">
                  {this.state.loading ? (
                    <CircularProgress color={"white"} size={25} />
                  ) : (
                    "Update Component"
                  )}
                </Button>
              </form>
            </div>
          </Modal>
          <Modal
            visible={this.state.materialEdit}
            width="300"
            height="470"
            effect="fadeInUp"
            onClickAway={() => this.closeModal()}
          >
            <div className="modalWrapper">
              <img
                src={yes}
                alt=""
                style={{ position: "absolute", right: "44px", top: "10px" }}
              />
              <CloseSharpIcon
                style={{ position: "absolute", right: "10px", top: "5px" }}
                onClick={() => this.closeModal()}
              />
              <form action="" id="materialForm" onSubmit={this.updateMaterial}>
                <h1 className="modalHead">Preview</h1>

                {this.state.type === "color" ? (
                  <div
                    className="modalBox"
                    style={{
                      backgroundColor: this.state.material_value
                        ? this.state.material_value
                        : "red",
                    }}
                  ></div>
                ) : (
                  <div>
                    {this.state.material_value ? (
                      <img
                        src={API.imgUrl + this.state.material_value}
                        width="105px"
                        height="105px"
                        style={{ marginBottom: "10px" }}
                        alt=""
                      />
                    ) : (
                      <img
                        src={rectangle}
                        width="105px"
                        height="105px"
                        style={{ marginBottom: "10px" }}
                        alt=""
                      />
                    )}
                  </div>
                )}
                <div className="inputTextWrap">
                  <span className="modalText">Name</span>
                  <input
                    type="text"
                    className="modalInput"
                    required
                    name="material_name"
                    defaultValue={this.state.material_name}
                    onChange={this.handleInput}
                  />
                </div>

                <Typography className="modalMaterialHead"> Material</Typography>

                <div style={{ marginBottom: "20px" }}>
                  <span
                    className="modalMaterialHead"
                    style={{
                      marginRight: "80px",
                      borderBottom: "none",
                      fontWeight: this.state.type === "color" ? "bold" : 400,
                    }}
                    onClick={() =>
                      this.setState({
                        addColor: true,
                        addSwatch: false,
                        type: "color",
                      })
                    }
                  >
                    Solid Color
                  </span>
                  <img src={verticalLine} className="varticalLine" alt="" />
                  <span
                    className="modalText"
                    style={{
                      fontWeight: this.state.type === "swatch" ? "bold" : 400,
                    }}
                    onClick={() =>
                      this.setState({
                        addSwatch: true,
                        addColor: false,
                        type: "swatch",
                      })
                    }
                  >
                    Swatch
                  </span>
                </div>

                {this.state.addColor ? (
                  <div>
                    <div
                      className={
                        this.state.colorPicker
                          ? "inputTextWrap2"
                          : "inputTextWrap"
                      }
                    >
                      <span
                        className="modalText"
                        style={{ marginLeft: " -8px" }}
                      >
                        Hexcode
                      </span>
                      <input
                        type="text"
                        className="modalInput"
                        name="material_value"
                        onClick={() =>
                          this.setState({
                            colorPicker: !this.state.colorPicker,
                          })
                        }
                        value={
                          this.state.material_value
                            ? this.state.material_value
                            : "#000"
                        }
                      />
                      {this.state.colorPicker ? (
                        <SketchPicker
                          name="material_value"
                          color={this.state.material_value}
                          onChangeComplete={this.handleChangeComplete}
                          width="350px"
                        />
                      ) : null}
                    </div>
                  </div>
                ) : null}
                {this.state.addSwatch ? (
                  <div>
                    <Button
                      variant="outlined"
                      size="medium"
                      className="uploadbtnswatch"
                      component="label"
                      style={{ margin: "11px auto" }}
                    >
                      Upload Swatch
                      <input
                        type="file"
                        onChange={this.onImageChange}
                        name="file"
                        hidden
                      />
                    </Button>
                    <Typography className="modalHead">
                      {this.state.file
                        ? "Swatch Uploaded"
                        : "accepted file types : .jpeg, .png"}
                    </Typography>
                  </div>
                ) : null}
                <Button className="uploadbtnswatch" type="submit">
                  Update Material
                </Button>
              </form>
            </div>
          </Modal>
          <Modal
            visible={this.state.deleteConfirmation}
            width="400"
            height="300"
            effect="fadeInUp"
            onClickAway={() => this.setState({ deleteConfirmation: false })}
          >
            <div className="confirmationModal" style={{ textAlign: "center" }}>
              <Typography>
                {this.state.Variants.length > 0
                  ? "All variants belongs to this material will be deleted.Are you sure you want to delete this material?"
                  : " Are you sure you want to delete this material ?"}
              </Typography>
              <Button
                onClick={() => {
                  this.deleteMaterial(
                    this.state.deleteMatId,
                    this.state.isAvailable
                  );
                }}
                className="DeleteBtn"
              >
                Delete
              </Button>
              <Button
                onClick={() => this.setState({ deleteConfirmation: false })}
                className="DeleteBtn"
                style={{ background: "#bdbdbd" }}
              >
                Cancel
              </Button>
            </div>
          </Modal>
          <Modal
            visible={this.state.confirmationComponentDelete}
            width="400"
            height="300"
            effect="fadeInUp"
            onClickAway={() =>
              this.setState({ confirmationComponentDelete: false })
            }
          >
            <div className="confirmationModal" style={{ textAlign: "center" }}>
              {this.state.Variants.length > 0 ? (
                <Typography>
                  All Variants of this product will be deleted. Are you sure you
                  want to delete this component ?
                </Typography>
              ) : (
                <Typography>
                  Are you sure you want to delete this component ?
                </Typography>
              )}

              <Button
                onClick={() => {
                  this.deleteComponent(this.state.deleteCompId);
                }}
                className="DeleteBtn"
              >
                Delete{" "}
              </Button>
              <Button
                onClick={() =>
                  this.setState({ confirmationComponentDelete: false })
                }
                className="DeleteBtn"
                style={{ background: "#bdbdbd" }}
              >
                Cancel
              </Button>
              <Typography style={{ color: "green" }}>
                {this.state.notification ? this.setState.successMsg : ""}
              </Typography>
            </div>
          </Modal>
          <Modal
            visible={this.state.confirmationComponentAdd}
            width="400"
            height="300"
            effect="fadeInUp"
            onClickAway={() =>
              this.setState({ confirmationComponentAdd: false })
            }
          >
            <div className="confirmationModal" style={{ textAlign: "center" }}>
              <Typography>
                All Variants of this product will be deleted. Are you sure you
                want to delete Variants ?
              </Typography>

              <Button
                onClick={() => {
                  this.variantDelete();
                }}
                className="DeleteBtn"
              >
                Delete{" "}
              </Button>
              <Button
                onClick={() =>
                  this.setState({ confirmationComponentAdd: false })
                }
                className="DeleteBtn"
                style={{ background: "#bdbdbd" }}
              >
                Cancel
              </Button>
              <Typography style={{ color: "green" }}>
                {" "}
                {this.state.notification ? this.state.successMsg : ""}
              </Typography>
            </div>
          </Modal>
          <Modal
            visible={this.state.variantUpdate}
            width="400"
            height="300"
            effect="fadeInUp"
            onClickAway={() => this.setState({ variantUpdate: false })}
          >
            <div
              className="inputWrapper"
              style={{
                padding: "20px",
                textAlign: "center",
                marginTop: "30px",
              }}
            >
              <form action="">
                <Typography>Upload model file</Typography>
                <Button
                  variant="outlined"
                  size="medium"
                  className="uploadbtnswatch"
                  component="label"
                  style={{
                    margin: "11px auto",
                    textTransform: "capitalize",
                    width: "33%",
                  }}
                >
                  Upload
                  <input
                    type="file"
                    onChange={this.handlevariantModal}
                    name="model_file"
                    id="uploadVariant"
                    hidden
                    className="imageUpload"
                  />
                </Button>
                <p> {this.state.model_file ? "File Uploaded" : ""}</p>
                <br />
                <Button
                  onClick={() => this.variant_update(this.state.variantId)}
                  className="DeleteBtn"
                  style={{
                    background: "#bdbdbd",
                    textTransform: "capitalize",
                    color: "#fff",
                  }}
                >
                  {this.state.loading ? (
                    <CircularProgress color={"white"} size={25} />
                  ) : (
                    "Update Variant"
                  )}
                </Button>
                <p style={{ color: "green" }}>
                  {this.state.notification ? this.state.successMsg : ""}
                </p>
              </form>
            </div>
          </Modal>
          <Modal
            visible={this.state.openBuyNow}
            width="400"
            height="450"
            effect="fadeInUp"
            onClickAway={() => this.setState({ openBuyNow: false })}
          >
            <div
              className="inputWrapper"
              style={{
                padding: "20px",
                textAlign: "center",
                marginTop: "30px",
              }}
            >
              <form action="" onSubmit={this.updateProduct}>
                <div className="modalWrapper">
                  <h4 style={{ marginTop: "-10px" }}>Edit product details</h4>

                  <div className="contentWrap">
                    <p>Link URL</p>
                    <input
                      type="text"
                      name="link_url"
                      className="modalInput"
                      style={{ marginBottom: "10px" }}
                      defaultValue={
                        this.state.product ? this.state.product.link_url : ""
                      }
                      onChange={this.handleInput}
                      required
                    />{" "}
                    <p>Link Title</p>
                    <input
                      type="text"
                      name="link_title"
                      className="modalInput"
                      style={{ marginBottom: "10px" }}
                      defaultValue={
                        this.state.product ? this.state.product.link_title : ""
                      }
                      onChange={this.handleInput}
                      required
                    />{" "}
                    <p>Link Description</p>
                    <input
                      type="text"
                      name="link_description"
                      className="modalInput"
                      style={{ marginBottom: "10px" }}
                      defaultValue={
                        this.state.product
                          ? this.state.product.link_description
                          : ""
                      }
                      onChange={this.handleInput}
                      required
                    />
                    <br />
                    <Button
                      className="addBtn"
                      type="submit"
                      style={{ width: "100%", marginLeft: "0px" }}
                    >
                      {this.state.loading ? (
                        <CircularProgress color={"white"} size={25} />
                      ) : (
                        "Update"
                      )}
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          </Modal>
        </Container>
      );
    }
  }
}
